import axios from 'axios';
import config from './../../../common/config/env'; 
import { axiosAuthInterceptor } from './authInterceptor';
const s3Api= axios.create({
    baseURL: `${config.s3APIBaseUrl}`
    
});

s3Api.interceptors.request.use(
    axiosAuthInterceptor,
    (error)=> Promise.reject(error)
);

export default s3Api;